import ContractReceivables from './ContractReceivables.vue'
export default ContractReceivables


// WEBPACK FOOTER //
// ./src/pages/ContractReceivables/index.js